<template>
    <div id="got-award" v-if="show">
        <div class="mask" @touchmove="touchMove" data-spider="getaward">
            <div :class="['content',code?'code':'']">
                <div class="img" :style="{backgroundImage:`url(${img})`}"></div>
                <p class="name" v-if="awardType === 2 || awardType === 1">{{name}}</p>
                <div v-if="awardType === 1">
                    <div class="link" v-if="!code" @click="goInfoPage" data-spider>
                        <div class="get-code" :data-awardid="awardId">获取兑奖码</div>
                    </div>
                    <div class="link" v-else @click="goAwardsPage" data-spider>
                        <div class="show-code">兑奖码：{{code}}</div>
                    </div>
                </div>
                <div v-else-if="awardType === 2">
                    <div class="link">
                        <a :href="couponLink" class="go-coupon">查看优惠券</a>
                    </div>
                </div>
                <div v-else-if="awardType === 4 && getCalculusLink">
                    <div class="link calculus-link">
                        <a :href="getCalculusLink">中奖啦！立即领取</a>
                    </div>
                </div>
            </div>
            <i class="cancel" @click="cancel"></i>
        </div>
    </div>
</template>
<style>

</style>
<script type="text/ecmascript-6">
    import '../css/getaward.less';
    import config from '../../../config/api.config'

    export default {
        data() {
            return {
                show: false,
                name: '',
                img: '',
                code: '',
                awardId: -1,
                awardType: -1,//1实物 2 优惠券 4微积分红包
                couponLink: '#',
                getCalculusLink: ''
            }
        },
        components: {},
        methods: {
            cancel() {
                this.show = false;
                this.getCalculusLink ='';
            },
            touchMove(e) {
                e.preventDefault();
                e.stopPropagation();
            },
            goInfoPage(e) {
                //location.href = `./com.html?id=${app.id}&code=${app.code}#/info?awardId=${this.awardId}`;
                let originUrl = `./com.html?id=${app.id}&code=${app.code}#/info?awardId=${this.awardId}`;
                let newUrl = spider.transferActionBy(originUrl, e.currentTarget);
                location.href = newUrl;


            },
            goAwardsPage(e) {
                //location.href = `./com.html?id=${app.id}&code=${app.code}#/awards`;
                let originUrl = `./com.html?id=${app.id}&code=${app.code}#/awards`;
                let newUrl = spider.transferActionBy(originUrl, e.currentTarget);
                location.href = newUrl;
            }
        },
        mounted() {
            let self = this;
            eventBus.$on('show', function (data) {
                self.show = true;
                self.name = data.name;
                self.img = data.pic;
                self.code = data.winerCode;
                self.awardId = data.id;
                self.awardType = data.awardType;
                if (data.awardType === 2) {//优惠券
                    self.couponLink = "https://i.weidian.com/my-coupons.php?pfr=coupon";
                }
            });
            eventBus.$on('hide', function (data) {
                self.show = false;
                self.getCalculusLink ='';
            });
            eventBus.$on('shopId', function (shopId) {
                self.getCalculusLink = config.openCalculusLink + shopId;
            });
        }
    }
</script>



/** WEBPACK FOOTER **
 ** getaward.vue?fdaf3320
 **/